import { UseFormReturn } from 'react-hook-form'

import type { ConvertStablesFormSchema } from '../../logic/form/schema'
import { ConvertStablesFormFields } from '../../types'
import { Form } from '@/ui/atoms/form/Form'
import { AssetInput } from '@/ui/organisms/asset-input/AssetInput'

export interface ConvertStablesFormProps {
  formFields: ConvertStablesFormFields
  form: UseFormReturn<ConvertStablesFormSchema>
}

export function ConvertStablesForm({ formFields, form }: ConvertStablesFormProps) {
  const {
    selectedAssetIn,
    selectedAssetInBalance,
    selectedAssetOut,
    changeAssetIn,
    changeAssetOut,
    assetInOptions,
    assetOutOptions,
    maxSelectedFieldName,
  } = formFields

  return (
    <Form {...form}>
      <AssetInput
        label="From"
        fieldName="amount"
        control={form.control}
        selectorAssets={assetInOptions}
        selectedAsset={selectedAssetIn}
        setSelectedAsset={changeAssetIn}
        maxSelectedFieldName={maxSelectedFieldName}
        maxValue={selectedAssetInBalance}
        showError
      />
      <AssetInput
        label="To"
        fieldName="amount"
        control={form.control}
        selectorAssets={assetOutOptions}
        selectedAsset={selectedAssetOut}
        setSelectedAsset={changeAssetOut}
        maxSelectedFieldName={maxSelectedFieldName}
        maxValue={selectedAssetInBalance}
        showError={false}
      />
    </Form>
  )
}
